import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import cl from "classnames";
import ArrowPopup from "venuescanner-js/react/components/ArrowPopup/ArrowPopup";
import classes from "../styles/styles.module.scss";
import PinnedElement from "../form/Stage0/PinnedElement";

const QuestionMark = ({
  text = "",
  matchWidth = false,
  classType,
  children,
  popupClassName,
}) => {
  const ref = useRef(null);
  const [popupShowing, setPopupShowing] = useState(false);

  useEffect(() => {
    const listener = (e) => {
      if (e.target === ref.current) return;
      setPopupShowing(false);
    };
    document.addEventListener("click", listener);

    return () => document.removeEventListener("click", listener);
  });

  const onClick = (e) => {
    e.preventDefault();
    if (e.target !== ref.current) return;
    setPopupShowing(!popupShowing);
  };

  return (
    <>
      <span
        ref={ref}
        role="button"
        className={classes[classType || "QuestionMark"]}
        onClick={onClick}
      >
        {text}
      </span>
      <PinnedElement pinTo={ref} matchWidth={matchWidth}>
        <ArrowPopup
          className={cl(classes.QuestionMark__popup, popupClassName)}
          show={popupShowing}
          below
        >
          {children}
        </ArrowPopup>
      </PinnedElement>
    </>
  );
};

QuestionMark.propTypes = {
  text: PropTypes.string,
  classType: PropTypes.string,
  children: PropTypes.node.isRequired,
  popupClassName: PropTypes.string,
  matchWidth: PropTypes.bool,
};

export default QuestionMark;
